import {ComplianceAreaCategory, ControlItem, TreeInformation,} from './index';

import {UploadStatus} from '../helpers/index';

export class ComplianceArea {
  complianceAreaId: number;
  name: string;
  controlItems: ControlItem[];
  checked: boolean = true;
  tenantName: string;
  children: ComplianceAreaCategory[];
  assignedClient: any;
  data: TreeInformation;

  lastModifiedDate: Date;
  remoteLastModifiedDate: Date | null;
  remoteUploadStatus: UploadStatus;
  uploadComment: string;
  isExtended: boolean;
  hasLevels: boolean;
  securityAssessmentVisibility: number;
  riskAssessmentVisibility: number;
  isFedRamp: boolean;
  maxScore?: number;

  constructor(name: string, controlItems: ControlItem[]) {
    this.name = name;
    this.controlItems = controlItems;
  }
}
